/* Amazon-style rating badge (llm-rating-badge.liquid) - on the product
   page, clicking the badge should smoothly pan down to the reviews
   section (matching the feel of Klaviyo's own review widget link),
   not the browser's default instant jump-to-anchor.

   The "llm_reviews" app section's real rendered wrapper ID is
   Shopify's own auto-generated "shopify-section-{template-id}__llm_
   reviews" (the {template-id} part varies per template, not something
   Liquid can look up from a different section's own render context) -
   matched here by suffix once, then given a clean, stable "reviews" id
   so the badge's own href can just be "#reviews" directly.
*/
function assignReviewsAnchorId() {
  if (document.getElementById('reviews')) return;
  const target = document.querySelector('[id$="__llm_reviews"], [id="shopify-section-llm_reviews"]');
  if (target) target.id = 'reviews';
}
assignReviewsAnchorId();

// Capture phase, not bubble - confirmed some other click handler on the
// page (product-card "instant" link preloading, most likely) calls
// stopPropagation() during the bubble phase, which silently prevented a
// bubble-phase listener here from ever seeing the click at all.
document.addEventListener(
  'click',
  (event) => {
    /* "Ask a question" beside the stars (owner 2026-11-02): pan down to the Q&A block. Aimed at
       .llm-product-qa itself, not the #llm-ask card, because on mobile llm-product-reviews-mobile.js
       moves the block out of that card (which is then hidden) into the accordion stack. */
    const ask = event.target.closest('[data-llm-scroll-to-ask]');
    if (ask) {
      const qa = document.querySelector('.llm-product-qa');
      if (!qa) return;
      event.preventDefault();
      // Same manual window.scrollTo as below (scrollIntoView no-ops on this page); 110 clears the sticky header.
      // INSTANT, not smooth (owner 2026-11-02: "make the scroll instant instead of scrolling down slowly").
      window.scrollTo({ top: qa.getBoundingClientRect().top + window.scrollY - 110, behavior: 'instant' });
      return;
    }

    const link = event.target.closest('[data-llm-scroll-to-reviews]');
    if (!link) return;

    assignReviewsAnchorId();
    let target = document.getElementById('reviews');
    if (!target) return;

    // On mobile the reviews were relocated into the "Reviews -" accordion
    // (llm-product-reviews-mobile.js). While that panel is collapsed the
    // #reviews node is display:none and has no scroll position, so open the
    // accordion and aim at it instead of the buried node. On desktop #reviews
    // stays in its own section, so this branch is skipped.
    let offset = 0;
    const accordion = target.closest('.llm-pd-accordion--reviews');
    if (accordion) {
      accordion.classList.add('is-open');
      const header = accordion.querySelector('.llm-pd-accordion__header');
      if (header) header.setAttribute('aria-expanded', 'true');
      target = accordion;
      offset = 80; // clear the sticky site header so the dropdown header shows
    }

    event.preventDefault();
    // Not target.scrollIntoView({behavior:'smooth'}) - confirmed on the
    // live page that call silently no-ops (window.scrollTo with the
    // same behavior option works fine standalone), so computing the
    // offset manually and scrolling the window directly sidesteps
    // whatever specifically breaks scrollIntoView here.
    const top = target.getBoundingClientRect().top + window.scrollY - offset;
    window.scrollTo({ top, behavior: 'instant' });
  },
  true
);
